/**
 * Google AdSense and Analytics loaders.
 *
 * The previous UI injected these from its Layout on mount; ui2 lost them in the
 * port, so the live site currently serves no ads and records no analytics. Both
 * are gated on their env id being set, so a build without the ids is a clean
 * no-op rather than a broken script tag.
 *
 * The ids are public (inlined into the bundle, and in ads.txt), so there is
 * nothing secret here -- see packages/ui2/.env.
 */

let adsenseLoaded = false

/** Injects the AdSense loader once. Both Auto Ads and any <ins> unit need it. */
export function loadAdSense(client = import.meta.env.VITE_ADSENSE): void {
    if (adsenseLoaded || !client || typeof document === 'undefined') return
    adsenseLoaded = true

    const script = document.createElement('script')
    script.async = true
    script.crossOrigin = 'anonymous'
    script.src = `https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js?client=${client}`
    document.head.appendChild(script)
}

let gaLoaded = false

/** Injects gtag.js once and configures the property. */
export function loadGoogleAnalytics(id = import.meta.env.VITE_GA): void {
    if (gaLoaded || !id || typeof document === 'undefined') return
    gaLoaded = true

    const script = document.createElement('script')
    script.async = true
    script.src = `https://www.googletagmanager.com/gtag/js?id=${id}`
    document.head.appendChild(script)

    window.dataLayer = window.dataLayer || []
    const gtag = (...args: unknown[]) => { window.dataLayer!.push(args) }
    window.gtag = gtag
    gtag('js', new Date())
    // send_page_view stays on (the default) so the first load is counted; SPA
    // navigations are sent explicitly by trackPageView
    gtag('config', id)
}

/** Records a client-side navigation. The initial page is counted by config, so
    callers should skip the first render to avoid double counting. */
export function trackPageView(path: string): void {
    const id = import.meta.env.VITE_GA
    if (!id || typeof window.gtag !== 'function') return
    window.gtag('event', 'page_view', { page_path: path, page_location: window.location.href })
}
